export const DEMO_GRID_ENTITIES_GRID = 'demoGridEntities';
export const ORDER_TRANSPORTS_CARD = 'orderTransports';
export const ORDER_TRANSPORT_AUCTIONS_CARD = 'auctions';
export const REGISTER_DM_CARD = 'registerDm';
export const REGISTER_CARRIER_CARD = 'registerCarrier';
export const FINE_DM_BILL_CARD = 'fineDmBillsGrid'
export const ORDERS_GRID = 'orders';
export const AUTOBLOCKING_WARRANTIES_GRID = 'autoblockingWarranties';
